import { DateTime } from 'luxon';
import { PreferredWorkerProposal } from 'api/services/shift/dto/preferred-worker-proposals.dto';
import {
  PreferredWorkersColumnDefinition,
  PreferredWorkersTableOptions,
} from '../preferred-workers-table.types';

export const getPreferredWorkersTableData = (
  preferredWorkers: PreferredWorkerProposal[],
  tableOptions: PreferredWorkersTableOptions
): PreferredWorkersColumnDefinition[] => {
  return preferredWorkers.map((worker) => {
    return {
      id: worker.id,
      workerFullName: worker.workerFullName,
      workName: worker.workName,
      companyName: worker.companyName,
      departmentName: worker.departmentName,
      dateTime: {
        fromDateTime: DateTime.fromISO(worker.dateTime.fromDateTime),
        toDateTime: DateTime.fromISO(worker.dateTime.toDateTime),
      },
      actions: {
        onAccept: () => tableOptions.onAcceptWorker(worker.id),
        onReject: () => tableOptions.onRejectWorker(worker.id),
      },
    };
  });
};
